var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTabClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.34375C8.20833 0.34375 9.32292 0.645833 10.3438 1.25C11.3646 1.83333 12.1667 2.63542 12.75 3.65625C13.3542 4.67708 13.6562 5.79167 13.6562 7C13.6562 8.20833 13.3542 9.32292 12.75 10.3438C12.1667 11.3646 11.3646 12.1771 10.3438 12.7812C9.32292 13.3646 8.20833 13.6562 7 13.6562C5.79167 13.6562 4.67708 13.3646 3.65625 12.7812C2.63542 12.1771 1.82292 11.3646 1.21875 10.3438C0.635417 9.32292 0.34375 8.20833 0.34375 7C0.34375 5.79167 0.635417 4.67708 1.21875 3.65625C1.82292 2.63542 2.63542 1.83333 3.65625 1.25C4.67708 0.645833 5.79167 0.34375 7 0.34375ZM9.40625 3.65625L7 6.0625L4.59375 3.65625L3.65625 4.59375L6.0625 7L3.65625 9.40625L4.59375 10.3438L7 7.9375L9.40625 10.3438L10.3438 9.40625L7.9375 7L10.3438 4.59375L9.40625 3.65625Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabClose);
export default __webpack_public_path__ + "static/media/icon_tab_close.abad5d265133280b436ad7964e970eac.svg";
export { ForwardRef as ReactComponent };